import React from 'react';
import './MultiProductListing.scss';
import ProductSummary from '../ProductSummary/ProductSummary';

/**
 * Renders the multi product listing component
 * @param {string} title
 * @param {array} products
 * @param {string} starsAssetUrl
 * @param {function} addToCart
 * @returns {JSX.Element}
 * @constructor
 */
const MultiProductListing = ({
  title = '',
  products = [],
  starsAssetUrl = '',
  addToCart = null,
}) => {
  const renderProducts = (products) =>
    products.map((product) => (
      <div className="c-multi-product-listing__product">
        <div className="c-multi-product-listing__product-image">
          <img src={product?.mainImage?.url} alt={product?.mainImage?.alt} />
        </div>
        <div className="c-multi-product-listing__product-summary">
          <ProductSummary
            isHeroProductListing={false}
            product={product}
            starsAssetUrl={starsAssetUrl}
            addToCart={addToCart}
          />
        </div>
      </div>
    ));

  return (
    <div className="c-multi-product-listing background-color-gray">
      <div className="c-multi-product-listing__inner">
        <div className="c-multi-product-listing__title h2-roobert">
          <h2>{title}</h2>
        </div>
        <div className="c-multi-product-listing__products">{renderProducts(products)}</div>
      </div>
    </div>
  );
};

export default MultiProductListing;
